export const NO_SAMPLES_AVAILABLE = 'No samples are available.';

export const NO_SAMPLES_AVAILABLE_FOR_THIS_DESTINATION =
  'No samples are available that can be used in the selected destination.';

export const NO_DESTINATIONS_AVAILABLE = 'No columns in the selected table can receive samples.';
